export default __webpack_public_path__ + "static/media/image.itechro-private-limited.a95d351e.png";